import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { COPY } from './copy';
import { compactMoney } from './format';
import { impactOf, rangeAcross, IMPACT_LABELS } from '../shared/impact';

const NAMED = 2;

// What a coach reply proposed, in one line under it. The proposals
// themselves wait in the Actions panel (Accept / Not now), so a reply with
// several of them stays short; "Review in Actions" opens the panel.
export default function SuggestionsSummary({ proposals = [], openKeys = [], coachName, onReview }) {
  if (!proposals.length) return null;
  const open = proposals.filter((p) => openKeys.includes(p.key)).length;
  // Ranges are per business category, so proposals in one category share one.
  const range = rangeAcross(proposals.map((p) => impactOf(p)));
  const titles = proposals.slice(0, NAMED).map((p) => p.title).join(', ');
  const more = proposals.length - NAMED;

  return (
    <div
      data-testid="suggestions-summary"
      className="flex flex-wrap items-center justify-between gap-x-5 gap-y-3 border border-border rounded-xl bg-card py-3.5 px-[18px]"
    >
      <div className="flex flex-col gap-1 min-w-0 flex-1 basis-full sm:basis-0">
        <span className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
          <span className="text-[14px] font-medium text-foreground">{COPY.suggestedSummary(coachName, proposals.length)}</span>
          {range ? (
            <span className="font-label text-[11px] text-teal-ink tabular-nums whitespace-nowrap" title={IMPACT_LABELS.range}>
              roughly {compactMoney(range[0])}–{compactMoney(range[1])} across these areas
            </span>
          ) : null}
        </span>
        <span className="text-[13px] leading-normal text-muted-foreground">
          {titles}
          {more > 0 ? ` ${COPY.andMore(more)}` : ''}
        </span>
      </div>
      {open > 0 ? (
        <button
          type="button"
          onClick={onReview}
          className="inline-flex items-center gap-1.5 min-h-9 px-[18px] rounded-full border-0 bg-orange-cta text-white text-[13px] font-medium cursor-pointer"
        >
          {COPY.reviewInActions}
          {open < proposals.length ? ` (${open})` : ''}
          <ArrowRight size={14} />
        </button>
      ) : (
        <span className="inline-flex items-center gap-1.5 text-[13px] font-medium text-teal-ink">
          <CheckCircle2 size={16} /> {COPY.suggestedDone}
        </span>
      )}
    </div>
  );
}
